import { Trans, useTranslation } from 'react-i18next'

export const ActivityVotesRefilledItem = () => {
  const { t } = useTranslation('common')
  return <Trans>{t('activity.item.votes.refilled')}</Trans>
}
